import Logo from "../../img/she-logo-new.svg";

function HeaderInternal() {
    return (
        <>
            <header className="py-3 bg-[#2b3d87] bg-white shadow-xl">
                <div className="container px-3 mx-auto flex justify-between items-center">
                    <a href="/">
                        <img src={Logo} alt="Business Wisdom Summit" className="w-[100px]"/>
                    </a>
                    <nav>
                        <ul className="flex gap-4 text-black">
                            <li><a href="/">Головна</a></li>
                        </ul>
                    </nav>
                </div>

            </header>
        </>
    )
}

export default HeaderInternal;